const FormCategory = ({ category }: { category: string }) => (
  <div className="w-full bg-grey">
    <h3 className="py-5 px-3.5 font-bold">{category}</h3>
  </div>
);

export default FormCategory;
